module.exports = __webpack_public_path__ + "img/SK36854140.f694b7ee.png";